import { Component, OnInit, ViewContainerRef, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedData } from '../../shared/sharedData';
import { Configuration } from '../../shared/services/configuration';
import { HttpClientCustom } from '../../shared/services/http.client';
import * as _ from 'underscore';
import { Auth } from '../../shared/services/auth';
import { ToasterComponent } from '../../toasterComponent/toasterComponent';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'ScheduleAnnouncement',
    host: {
        '(document:click)': 'onClick($event)',
    },
    templateUrl: 'scheduleAnnouncement.html',
})
export class ScheduleAnnouncement {
    dynamicId;
    public localState: any;
    public _baseUrl: any;
    meridian = true;
    spinners = false;
    public announcementData: any = {};
    public minStartDate: any = {};
    activationTime: any = {
        "hour": null,
        "minute": null
    };
    public buttonStatus: any = false;
    public now: any;

    constructor(
        public route: ActivatedRoute,
        public activeModal: NgbActiveModal,
        public _global: Configuration,
        public http: HttpClientCustom,
        public _auth: Auth,
        public share: SharedData,
        public translate:TranslateService,
        public _toaster: ToasterComponent, vcr: ViewContainerRef,
        public _eref: ElementRef

    ) {
        this._baseUrl = _global.get("EPMS_BASE_URL");
        this.setMinStartDate();
        this.announcementData = this.share.getData();
        this.now = new Date();
        this.activationTime.hour = this.now.getHours();
        this.activationTime.minute = this.now.getMinutes();
        this.activationTime.second = this.now.getSeconds();
        this.announcementData.activationDate = { year: this.now.getFullYear(), month: this.now.getMonth() + 1, day: this.now.getDate() };
    }

     // temporary fixes for cal close
    openDatePicker(id) {
        this.dynamicId = id;
    }

    // temporary fixes for cal close
    onClick(event) {
        if (event.target.tagName == 'BUTTON' || event.target.tagName ==  'I' || event.target.tagName == 'SELECT' || event.target.tagName == 'SPAN') {
        } else{
            let self = this;
            if (self.dynamicId.isOpen()) {
                setTimeout(function () {
                    self.dynamicId.close();
                }, 10);
            }
        }
    }
    public setMinStartDate() {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth();
        month = month + 1;
        let day = date.getDate();
        let endDateObj = {
            year: year,
            month: month,
            day: day
        };
        this.minStartDate = endDateObj;
    }

    toggleMeridian() {
        this.meridian = !this.meridian;
    }

    schedule() {
        if (this.announcementData.activationDate != null && this.activationTime != null) {
            if (this.announcementData.activationDate.day <= this.now.getDate()) {
                if (this.activationTime.hour != null) {
                    let hour = this.now.getHours();
                    if (this.activationTime.hour < hour) {
                        this.translate.get('selectedTimeNotValidForDate').subscribe((msg)=>{
                            this._toaster.showError(msg);
                        });
                        return false;
                    } else if (this.activationTime.hour == hour) {
                        let minute = this.now.getMinutes();
                        if (this.activationTime.minute < minute) {
                            this.translate.get('minNotValidForDateTime').subscribe((msg)=>{
                                this._toaster.showError(msg);
                            });
                            return false;
                        }
                    }
                }
            }
            let self = this;
            if (_.isObject(this.announcementData.activationDate)) {
                this.onStartDateChange(this.announcementData.activationDate);
            }
            if (_.isObject(this.announcementData)) {
                this.onActivationTimeChange(this.announcementData.activationDate, this.activationTime);
            }
            this.announcementData.activationDate = new Date(this.announcementData.activationDate);
            try {
                this.buttonStatus = true;
                let url = self._baseUrl + "v1/webAdmin/announcement/triggerAnnouncement";
                self.http.post(url, self.announcementData).subscribe(result => {
                    if (result.data != null) {
                        self.translate.get('checkEmpCode').subscribe((msg)=>{
                            self._toaster.showError(msg);
                        });
                        self.announcementData.contentData.extensions = [];
                        self.announcementData.groupIds = [];
                        self.announcementData.contentData.imgURL = [];
                        self.announcementData.contentData.videoURL = [];
                        self.announcementData.contentData.imageURL = [];
                        self.announcementData.employeeSearchFilter = null;
                    } else {
                        if (result.success) {
                            setTimeout(() => self.goToBackPage(), 1000);
                            self.translate.get('announcementSuccessfull').subscribe((msg)=>{
                                self._toaster.showSuccess(msg);
                            });
                        } else {
                            setTimeout(() => self.goToBackPage(), 1000);
                            self.translate.get('errorWhileAnnouncement').subscribe((msg)=>{
                                self._toaster.showError(msg);
                            });
                        }
                    }
                });

            } catch (e) {
                console.log("getAllEmployeeData error catch", e);
            }
        } else {
            this.translate.get('activationDateTime').subscribe((msg)=>{
                this._toaster.showError(msg);
            });
        }
    }

    onStartDateChange(e) {
        this.announcementData.activationDate = e.year + '-' + e.month + '-' + e.day;
    }

    onActivationTimeChange(e, f) {
        this.announcementData.activationDate = e + " " + f.hour + ':' + f.minute + ':' + f.second;
    }

    goToBackPage() {
        this.activeModal.close('confirmed');
    }
}



// WEBPACK FOOTER //
// ./src/app/programManagement/announcements/scheduleAnnouncement.ts